import axios from "axios";
import axiosInstance from "./AxiosInstance";
import { store } from "../store/store";

const edmApiBaseUrl = process.env.REACT_APP_API_URL;
const edmLocalHostApiBaseUrl = process.env.REACT_APP_LOCALHOST_API_URL;

const awsGlueJobsRoute = process.env.REACT_APP_AWS_GLUE_JOBS_ROUTE;
const awsGlueJobsRouteFromDb =
  process.env.REACT_APP_AWS_GLUE_JOBS_ROUTE_FROM_DB;
const awsEmrFetchRoute = process.env.REACT_APP_AWS_EMR_FETCH_ROUTE;
const awsEc2InstanceFetchRoute =
  process.env.REACT_APP_AWS_EC2_INSTANCE_FETCH_ROUTE;
const awsGlueJobsFromCacheRoute =
  process.env.REACT_APP_AWS_GLUE_JOBS_FROM_CACHE_ROUTE;
const awsGlobalDataRoute = process.env.REACT_APP_AWS_GLOBAL_DATA_ROUTE;

export function getAwsGlueJobs(env = "prd", refresh = false) {
  const url = `${awsGlobalDataRoute}?env=${env}&refresh=${refresh}`;
  console.log("Fetching AWS Glue Jobs from CACHE URL:", env);
  console.log("URL:", url);
  return axiosInstance
    .get(url)
    .then((response) => {
      const glueJobs = response.data.data.glueJobRunData;
      const emrClusters = response.data.data.emrClusterData;
      const ec2Instances = response.data.data.ec2Instances;
      const sqsData = response.data.data.sqsData?.length
        ? response.data.data.sqsData.sort(
            (a, b) => b.messagesAvailable - a.messagesAvailable
          )
        : [];
      const appflowData = response.data.data.appflowData;
      const ecsClusters = response.data.data.ecsClusterData;
      const awsAirflowData = response.data.data.airflowData;
      console.log("glueJobs:", glueJobs);

      return {
        glueJobs,
        emrClusters,
        ec2Instances,
        sqsData,
        appflowData,
        ecsClusters,
      };
    })
    .catch((error) => {
      console.error("Error fetching AWS Glue jobs:", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    });
}

export function getAwsGlueJobsFromDb() {
  return axiosInstance
    .get(awsGlueJobsRouteFromDb)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.error("Error fetching AWS Glue jobs from DB:", error);
      throw error;
    });
}

export function getAwsEmrFetch() {
  return axiosInstance
    .get(awsEmrFetchRoute)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.error("Error fetching AWS EMR fetch:", error);
      throw error;
    });
}

export function getEc2Instances() {
  return axiosInstance
    .get(awsEc2InstanceFetchRoute)
    .then((response) => {
      return response.data.data;
    })
    .catch((error) => {
      console.error("Error fetching AWS EC2 instances:", error);
      throw error;
    });
}

export async function getGlueData(env = 'prod', refresh = false) {
  // This function mimics getAwsGlueJobs but only returns the glueJobRunData
  const url = `${awsGlobalDataRoute}?env=${env}&refresh=${refresh}`;
  try {
    return axiosInstance
    .get(url)
    .then((response) => {
      const glueJobs = response.data.data.glueJobRunData;
      console.log("glueJobs:", glueJobs);
      return { glueJobRunData: glueJobs };
    })
    .catch((error) => {
      console.error("Error fetching AWS Glue data:", error);
      return { glueJobRunData: [] };
    });
  } catch (error) {
    console.error("Error fetching AWS Glue data:", error);
    throw error;
  }
}

export async function getAwsAirflowDataFromDb(env = "prod", refresh = false) {
  // This function mimics getGlueData but only returns the airflowData
  const url = `${awsGlobalDataRoute}?env=${env}&refresh=${refresh}`;
  try {
    return axiosInstance
      .get(url)
      .then((response) => {
        const airflowData = response.data.data.airflowData;
        console.log("airflowData:", airflowData);
        return { airflowData };
      })
      .catch((error) => {
        console.error("Error fetching AWS Airflow data:", error);
        return { airflowData: [] };
      });
  } catch (error) {
    console.error("Error fetching AWS Airflow data:", error);
    throw error;
  }
}

export async function getEMRDataFromDb(env = "prod", refresh = false) {
  // This function mimics getGlueData but only returns the emrData
  const url = `${awsGlobalDataRoute}?env=${env}&refresh=${refresh}`;
  try {
    return axiosInstance
      .get(url)
      .then((response) => {
        const emrData = response.data.data.emrData;
        console.log("emrData:", emrData);
        const emrClusterData = response.data.data.emrClusterData;
        console.log("emrClusterData:", emrClusterData);
        return { emrData, emrClusterData };
      })
      .catch((error) => {
        console.error("Error fetching AWS EMR data:", error);
        return { emrData: [] };
      });
  } catch (error) {
    console.error("Error fetching AWS EMR data:", error);
    throw error;
  }
}

export function getAwsAirflowData(env = "prod", refresh = false) {
  const url = `${edmApiBaseUrl}aws/airflow?env=${env}&refresh=${refresh}`;
  console.log("Fetching AWS Airflow data for environment:", env);
  console.log("URL:", url);
  console.log("Using cached data:", !refresh);


  return axiosInstance
    .get(url)
    .then((response) => {
      console.log("Full AWS Airflow response:", response);
      console.log("Response data:", response.data);
      console.log("Response data type:", typeof response.data);
      console.log("Response data keys:", Object.keys(response.data || {}));

      // grab whatever comes back
      const raw = response.data.data || response.data || [];
      console.log("Raw result:", raw);
      console.log("Result type:", typeof raw);
      console.log("Result is array:", Array.isArray(raw));
      console.log("================================================");

      let dagsList;
      // detect if this is an array of { environment_name, dags: [...] }
      if (
        Array.isArray(raw) &&
        raw.length > 0 &&
        raw[0].hasOwnProperty("dags") &&
        Array.isArray(raw[0].dags)
      ) {
        console.log(
          "Detected cluster-wrapper array with .dags → flattening now"
        );
        // flat-map all inner .dags arrays
        dagsList = raw.flatMap((cluster) => {
          console.log(
            ` • cluster "${cluster.environment_name}" has ${cluster.dags.length} DAGs`
          );
          return cluster.dags;
        });
      } else {
        console.log("No wrapper objects found, assuming flat list of DAGs");
        dagsList = Array.isArray(raw) ? raw : [];
      }

      console.log("Flattened DAG list length:", dagsList.length);
      console.log("Flattened airflowData:", dagsList);
      console.log("================================================");

      return dagsList;
    })
    .catch((error) => {
      console.error("Error fetching AWS Airflow data:", error);
      console.error("Error details:", error.response?.data || error.message);
      throw error;
    });
}
